import { drivelabels_v2 } from '@googleapis/drivelabels';
import { bulkDisableDriveLabels } from '../../../api/drive-labels-api';
import { Messages } from '../../../utils/message-constants';
import { DriveRoles } from '../../../utils/roles/client-roles';
import LabelActionDialog from './label-action-dialog';

type Label = drivelabels_v2.Schema$GoogleAppsDriveLabelsV2Label;

interface DisableLabelsDialogProps {
  open: boolean;
  handleClose: () => void;
  labels: Label[];
  changeLogRoles: string[];
  onDisabled: () => void;
}

export default function DisableLabelsDialog({
  open,
  handleClose,
  labels,
  changeLogRoles,
  onDisabled,
}: DisableLabelsDialogProps) {
  const count = labels.length;
  const name = labels[0]?.properties?.title;

  return (
    <LabelActionDialog
      open={open}
      handleClose={handleClose}
      labels={labels}
      changeLogRoles={changeLogRoles}
      changeLogRole={DriveRoles.UpdateDriveLabelsStatus.value}
      title={Messages.DriveLabels.DisableTitle(count)}
      body={
        count > 1 ? (
          Messages.DriveLabels.DisableBodyMany
        ) : (
          <>
            {Messages.DriveLabels.DisableBodyBefore}{' '}
            {name ? <strong>{name}</strong> : 'this label'}{' '}
            {Messages.DriveLabels.DisableBodyAfter}
          </>
        )
      }
      confirmLabel={Messages.DriveLabels.DisableButton}
      run={(labelIds, changeLogMessage) =>
        bulkDisableDriveLabels(labelIds, undefined, changeLogMessage)
      }
      successMessage={Messages.DriveLabels.DisableSuccess(count)}
      partialMessage={Messages.DriveLabels.DisablePartial}
      errorMessage={Messages.Errors.Network.Updating(
        count === 1 ? 'the label' : 'the labels'
      )}
      onDone={onDisabled}
    />
  );
}
